import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage, injectIntl } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'
import Modal from 'components/modal/Modal/Modal'
import CheckBox from 'components/forms/CheckBox/CheckBox'
import Message from 'components/text/Message/Message'

import messages from './messages'
import s from './ChooseFriendsToInviteModal.scss'


class ChooseFriendsToInviteModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
  }

  static defaultProps = {
    name: constants.modals.ChooseFriendsToInvite,
  }

  constructor({ data }) {
    super()

    this.state = {
      isFetching: false,
      searchValue: '',
      isActive: false,
      isAllContactsChecked: true,
      initContacts: data,
      contacts: data,
    }
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  handleInputChange = ({ target: { value = '' } }) => {
    const { initContacts } = this.state

    const filteredContacts = initContacts.filter(({ name } = {}) => (
      name && name.toLowerCase().includes(value.toLowerCase())
    ))

    this.setState({
      searchValue: value,
      contacts: filteredContacts,
    })
  }

  toggleContact = (index) => () => {
    const { contacts } = this.state

    const item = contacts[index]
    item.isActive = !item.isActive

    const newContacts = [
      ...contacts.slice(0, index),
      item,
      ...contacts.slice(index + 1),
    ]

    this.setState({
      contacts: newContacts,
    })
  }

  toggleContacts = () => {
    const { isAllContactsChecked, initContacts } = this.state

    const mapContacts = initContacts.map((contact) => ({ ...contact, isActive: !isAllContactsChecked }))

    this.setState({
      isAllContactsChecked: !isAllContactsChecked,
      contacts: mapContacts,
    })
  }

  sendInvitations = () => {
    const { contacts } = this.state

    const emails = contacts
      .filter((contact) => contact.isActive)
      .map((contact) => contact.email)

    this.setState({ isFetching: true })

    actions.models.me.inviteUser(emails)
      .then(() => {
        actions.models.modals.open(constants.modals.Dialog, {
          contentMessage: messages.emailsWereSent,
          buttonTitle: messages.ok,
        })

        this.close()
      })
  }

  render() {
    const { isFetching, searchValue, contacts, isAllContactsChecked } = this.state
    const { name, intl } = this.props

    const areContactsExist = Boolean(contacts && contacts.length)

    return (
      <Modal className={s.modal} name={name} title={messages.title}>
        <div>
          <input
            className={s.searchInput}
            placeholder={intl.formatMessage(messages.searchContacts)}
            value={searchValue}
            onChange={this.handleInputChange}
          />
        </div>
        <div className={s.contacts}>
          {
            areContactsExist ? (
              contacts.map(({ isActive, name, email }, index) => (
                <div className={s.contact} key={index}>
                  <div className={s.name}>
                    <CheckBox
                      onChange={this.toggleContact(index)}
                      checked={isActive}
                      type="checkbox"
                    >
                      <span className={s.name}>{name}</span>
                    </CheckBox>
                  </div>
                  <div className={s.email}>{email}</div>
                </div>
              ))
            ) : (
              <Message className={s.noContacts} text={messages.noContacts} tag="div" />
            )
          }
        </div>
        <div>
          <div className={s.actions}>
            <div>
              <CheckBox
                className={s.checkbox}
                checked={isAllContactsChecked}
                onChange={this.toggleContacts}
              >
                <FormattedMessage {...(isAllContactsChecked ? messages.uncheckAll : messages.checkAll)} />
              </CheckBox>
            </div>
            <div className={s.buttons}>
              <Button
                title={messages.cancel}
                fullWidth
                gray
                onClick={this.close}
              />
              <Button
                className={s.sendButton}
                title={messages.send}
                fullWidth
                brand
                loading={isFetching}
                onClick={this.sendInvitations}
              />
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}


export default injectIntl(ChooseFriendsToInviteModal)
